import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export type ReportContextType = {
  showInlineGlossaryDefinitions: boolean;
  updateContext: (context: Partial<ReportContextType>) => void;
};

export const REPORT_CONTEXT_DEFAULTS: ReportContextType = {
  showInlineGlossaryDefinitions: false,
  updateContext: noop,
};

export const ReportContext = createContext<ReportContextType>(
  REPORT_CONTEXT_DEFAULTS,
);

export function useReportContext() {
  const context = useContext(ReportContext);

  return context;
}
